var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E102"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E102",
    className: "cls-2",
    points: "137 221 239 221 239 342 206 342 206 364 138 364 137 221"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "E103"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E103",
    className: "cls-2",
    points: "241 230 340 230 340 343 241 342 241 230"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "E104"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E104",
    className: "cls-2",
    x: 344,
    y: 230,
    width: 121,
    height: 112
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "E94"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E94",
    className: "cls-2",
    x: 577,
    y: 230,
    width: 70,
    height: 112
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "E95"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E95",
    className: "cls-2",
    x: 651,
    y: 230,
    width: 99,
    height: 112
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "E96"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E96",
    className: "cls-2",
    points: "854 221 854 371 785 371 785 342 753 342 753 221 854 221"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "E97"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E97",
    className: "cls-2",
    points: "854 374 854 442 651 442 651 374 725 374 725 382 753 382 753 374 854 374"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "E98"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E98",
    className: "cls-2",
    points: "647 374 647 455 548 455 548 382 572 382 572 374 647 374"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "E99"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E99",
    className: "cls-2",
    points: "545 382 545 455 446 455 446 374 521 374 521 382 545 382"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "E100"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E100",
    className: "cls-2",
    points: "443 374 443 455 344 455 344 382 368 382 368 374 443 374"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "E101"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E101",
    className: "cls-2",
    points: "340 382 340 442 137 442 137 367 206 367 206 374 316 374 316 382 340 382"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgP7 as ReactComponent };